const BrazilCarbonCreditUnified = {
  "_format": "hh-sol-artifact-1",
  "contractName": "BrazilCarbonCreditUnified",
  "sourceName": "contracts/core/BrazilCarbonCreditUnified.sol",
  "abi": [
    {
      "inputs": [],
      "stateMutability": "nonpayable",
      "type": "constructor"
    },
    {
      "inputs": [],
      "name": "ACTIVE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ALREADY_APPROVED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ALREADY_AUDITED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ALREADY_CONFIGURED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ALREADY_FAILED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ALREADY_SIGNED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ALREADY_WITHDRAWN",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "AMOUNT_TOO_LOW",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "AUDITOR_IS_DEVELOPER",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "AUTH_AUDITOR",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "AUTH_CERTIFIER",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "AUTH_DEVELOPER",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "AUTH_FACTORY",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "AUTH_FACTORY_OWNER",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "AUTH_TOKEN",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "BAD_INPUT",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "BAD_PRICE_PRECISION",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "BAD_TO",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "CLOSED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "CREDITS_NOT_RECEIVED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "CREDIT_TOKEN_NOT_SET",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "EMPTY",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "EXCEEDS_STAGE_CAP",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "EXTERNAL_CREDITS",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "HIGH_COMMISSION",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "INSUFFICIENT_BALANCE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "INSUFFICIENT_STAGE_RESERVE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "INSUFFICIENT_TOTAL_RESERVE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "INVALID",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "INVALID_STAGE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "INVALID_YEAR",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "INVALID_YEARS",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "KYC_REQUIRED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "LEN",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "LEN_COSTS",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "LEN_PRICES",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "MAX_BATCH",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "MINT_FAILED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NOT_APPROVED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NOT_AUDITED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NOT_FAILED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NOT_SIGNED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NO_CHANGE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NO_FUNDS",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ONCHAIN_CREDITS",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "PROJECT_ENDED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "PROJECT_FAILED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "RESERVED_FUNDS",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "SSTORE2_WriteError",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "STAGE_AUDITED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "STAGE_DONE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "STAGE_NOT_FUNDED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "STAGE_PARAMS_MISSING",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "TOKENS_EXIST",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "WRONG_STABLE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "WRONG_YEAR",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "YEAR_NOT_CONFIGURED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ZERO_ADDR",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ZERO_ADDRESS",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ZERO_AMOUNT",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ZERO_AUDITOR",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ZERO_CONFIG",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ZERO_DEVELOPER",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ZERO_PREDICTED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ZERO_REFUND",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ZERO_STABLE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ZERO_TOKEN",
      "type": "error"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "AuditCureWindowCleared",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint64",
          "name": "flagTime",
          "type": "uint64"
        },
        {
          "indexed": false,
          "internalType": "uint64",
          "name": "eligibleAt",
          "type": "uint64"
        }
      ],
      "name": "AuditCureWindowStarted",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint64",
          "name": "cureWindow",
          "type": "uint64"
        }
      ],
      "name": "AuditCureWindowUpdated",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "token",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "CarbonCreditTokenConfigured",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "totalRealized",
          "type": "uint256"
        }
      ],
      "name": "CarbonCreditsDeposited",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "CarbonCreditsReceived",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "recipient",
          "type": "address"
        }
      ],
      "name": "CreditsTransferredForSale",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "totalRealized",
          "type": "uint256"
        }
      ],
      "name": "ExternalCarbonCreditsDeposited",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "stageIdx",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "FundsWithdrawn",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "version",
          "type": "uint8"
        }
      ],
      "name": "Initialized",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "user",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "tokensReceived",
          "type": "uint256"
        }
      ],
      "name": "Invested",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "Paused",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [],
      "name": "ProjectCompleted",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "maxYear",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "stageCount",
          "type": "uint8"
        }
      ],
      "name": "ProjectConfigured",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [],
      "name": "ProjectFailed",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "offering",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amountToMint",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "year",
          "type": "uint256"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "user",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "price",
          "type": "uint256"
        }
      ],
      "name": "PublicOfferingSet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "indexed": true,
          "internalType": "uint8",
          "name": "stageIdx",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "tokenAmount",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "usdcPaid",
          "type": "uint256"
        }
      ],
      "name": "RefundPaid",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "stageIndex",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "nextAuditYear",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "nextAuditStageIndex",
          "type": "uint8"
        }
      ],
      "name": "StageAudited",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "stageIndex",
          "type": "uint8"
        }
      ],
      "name": "StageMoved",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "stageIndex",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "nextSignYear",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "nextSignStageIndex",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "address",
          "name": "signer",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "issuedCredits",
          "type": "uint256"
        }
      ],
      "name": "StageSigned",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "Unpaused",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "indexed": false,
          "internalType": "uint128",
          "name": "predictedCredits",
          "type": "uint128"
        },
        {
          "indexed": false,
          "internalType": "uint64",
          "name": "claimTimestamp",
          "type": "uint64"
        }
      ],
      "name": "YearConfigured",
      "type": "event"
    },
    {
      "inputs": [],
      "name": "approve",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "approved",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "auditStage",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "auditWindowOpen",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "auditorValidation",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "auditorVerification",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "stageIdx",
          "type": "uint8"
        }
      ],
      "name": "canRefundStage",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "cancelUnsuccessfulAudit",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "cancelUnsuccessfulAuditByFactory",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "carbonCreditConfigured",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "carbonCreditToken",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "carbonCreditTokenId",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "certifier",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "token",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "configureCarbonCreditToken",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8[]",
          "name": "yearStageCounts",
          "type": "uint8[]"
        },
        {
          "internalType": "uint64[]",
          "name": "costs",
          "type": "uint64[]"
        },
        {
          "internalType": "uint64[]",
          "name": "prices",
          "type": "uint64[]"
        }
      ],
      "name": "configureStages",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint128",
          "name": "predictedCredits",
          "type": "uint128"
        },
        {
          "internalType": "uint64",
          "name": "claimTimestamp",
          "type": "uint64"
        }
      ],
      "name": "configureYear",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8[]",
          "name": "_years",
          "type": "uint8[]"
        },
        {
          "internalType": "uint128[]",
          "name": "predictedCredits",
          "type": "uint128[]"
        },
        {
          "internalType": "uint64[]",
          "name": "claimTimestamps",
          "type": "uint64[]"
        }
      ],
      "name": "configureYearBatch",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint128[]",
          "name": "predictedCredits",
          "type": "uint128[]"
        },
        {
          "internalType": "uint64[]",
          "name": "claimTimestamps",
          "type": "uint64[]"
        }
      ],
      "name": "configureYearBatchSequential",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "confirmAuditSuccess",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "cureWindow",
      "outputs": [
        {
          "internalType": "uint64",
          "name": "",
          "type": "uint64"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "currentBatchYear",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "currentStageIndex",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "depositCarbonCreditsFromBalance",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "depositCarbonCreditsFromExternal",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "depositCreditsFromExternalCertifier",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "depositNativeCredits",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "developer",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "developerFee",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "name": "externalCreditDeposit",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "factory",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "stageIdx",
          "type": "uint8"
        }
      ],
      "name": "getStageInfo",
      "outputs": [
        {
          "internalType": "uint64",
          "name": "cost",
          "type": "uint64"
        },
        {
          "internalType": "uint64",
          "name": "price",
          "type": "uint64"
        },
        {
          "internalType": "uint64",
          "name": "raised",
          "type": "uint64"
        },
        {
          "internalType": "uint64",
          "name": "feeCollected_",
          "type": "uint64"
        },
        {
          "internalType": "bool",
          "name": "signed",
          "type": "bool"
        },
        {
          "internalType": "bool",
          "name": "audited",
          "type": "bool"
        },
        {
          "internalType": "bool",
          "name": "withdrawn",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        }
      ],
      "name": "getYearConfig",
      "outputs": [
        {
          "internalType": "uint128",
          "name": "predictedCredits",
          "type": "uint128"
        },
        {
          "internalType": "uint128",
          "name": "realizedCredits",
          "type": "uint128"
        },
        {
          "internalType": "uint128",
          "name": "circulatingSupply",
          "type": "uint128"
        },
        {
          "internalType": "uint64",
          "name": "claimTimestamp",
          "type": "uint64"
        },
        {
          "internalType": "bool",
          "name": "finalized",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        }
      ],
      "name": "getYearStages",
      "outputs": [
        {
          "internalType": "uint64[]",
          "name": "costs",
          "type": "uint64[]"
        },
        {
          "internalType": "uint64[]",
          "name": "prices",
          "type": "uint64[]"
        },
        {
          "internalType": "uint64[]",
          "name": "raised",
          "type": "uint64[]"
        },
        {
          "internalType": "bool[]",
          "name": "signed",
          "type": "bool[]"
        },
        {
          "internalType": "bool[]",
          "name": "audited",
          "type": "bool[]"
        },
        {
          "internalType": "bool[]",
          "name": "withdrawn",
          "type": "bool[]"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_stableCoin",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "_developer",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "_auditorVerif",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "_auditorValid",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "_certifier",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "_usdcTreasuryAddress",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "_factory",
          "type": "address"
        },
        {
          "internalType": "uint8",
          "name": "_maxYear",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "_investorFee",
          "type": "uint8"
        },
        {
          "internalType": "address",
          "name": "_investmentToken",
          "type": "address"
        }
      ],
      "name": "initialize",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint64",
          "name": "amount",
          "type": "uint64"
        }
      ],
      "name": "invest",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "investmentToken",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "investorFee",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "investorFeeTotal",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "kycEnabled",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "kycWhitelist",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint256",
          "name": "seriesId",
          "type": "uint256"
        }
      ],
      "name": "linkCreditSeries",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "markProjectFailed",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "maxProjectYear",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "nextAuditStageIndex",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "nextAuditYear",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "nextSignStageIndex",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "nextSignYear",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "internalType": "uint256[]",
          "name": "ids",
          "type": "uint256[]"
        },
        {
          "internalType": "uint256[]",
          "name": "values",
          "type": "uint256[]"
        },
        {
          "internalType": "bytes",
          "name": "",
          "type": "bytes"
        }
      ],
      "name": "onERC1155BatchReceived",
      "outputs": [
        {
          "internalType": "bytes4",
          "name": "",
          "type": "bytes4"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "id",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        },
        {
          "internalType": "bytes",
          "name": "",
          "type": "bytes"
        }
      ],
      "name": "onERC1155Received",
      "outputs": [
        {
          "internalType": "bytes4",
          "name": "",
          "type": "bytes4"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "pause",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "pauseForUnsuccessfulAudit",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "paused",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "stageIdx",
          "type": "uint8"
        },
        {
          "internalType": "uint256",
          "name": "tokenAmount",
          "type": "uint256"
        }
      ],
      "name": "payoutRefund",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "usdcPaid",
          "type": "uint256"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "projectCompleted",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "projectFailed",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "publicOfferingAddress",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "year",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "stageIdx",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "tokenAmount",
          "type": "uint256"
        }
      ],
      "name": "refund",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "sale",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amountToMint",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "year",
          "type": "uint256"
        },
        {
          "internalType": "address",
          "name": "user",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "price",
          "type": "uint256"
        }
      ],
      "name": "seedPublicOffering",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint64",
          "name": "_cureWindow",
          "type": "uint64"
        }
      ],
      "name": "setAuditCureWindow",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "_rate",
          "type": "uint8"
        }
      ],
      "name": "setInvestorFee",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_kycWhitelist",
          "type": "address"
        },
        {
          "internalType": "bool",
          "name": "_enabled",
          "type": "bool"
        }
      ],
      "name": "setKYCWhitelist",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_treasuryAddress",
          "type": "address"
        },
        {
          "internalType": "uint8",
          "name": "_developerFee",
          "type": "uint8"
        }
      ],
      "name": "setTreasuryConfig",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "issuedCredits",
          "type": "uint256"
        }
      ],
      "name": "signStage",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "stableCoin",
      "outputs": [
        {
          "internalType": "contract IERC20",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        }
      ],
      "name": "stageCountForYear",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "startAudit",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "successfulAuditNumber",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes4",
          "name": "interfaceId",
          "type": "bytes4"
        }
      ],
      "name": "supportsInterface",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        }
      ],
      "name": "sweepUnclaimedCredits",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "totalRefundReserved",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "internalType": "address",
          "name": "recipient",
          "type": "address"
        }
      ],
      "name": "transferCreditsForSale",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "treasuryAddress",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "unpause",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "unsuccessfulAudit",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "unsuccessfulAuditFlagTime",
      "outputs": [
        {
          "internalType": "uint64",
          "name": "",
          "type": "uint64"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "usdcTreasuryAddress",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "withdrawFeesToTreasury",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "year",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "stageIdx",
          "type": "uint8"
        }
      ],
      "name": "withdrawFunds",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "name": "yearConfigs",
      "outputs": [
        {
          "internalType": "uint128",
          "name": "predictedCredits",
          "type": "uint128"
        },
        {
          "internalType": "uint128",
          "name": "realizedCredits",
          "type": "uint128"
        },
        {
          "internalType": "uint128",
          "name": "circulatingSupply",
          "type": "uint128"
        },
        {
          "internalType": "uint64",
          "name": "claimTimestamp",
          "type": "uint64"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "name": "yearCreditSeriesId",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    }
  ],
  "bytecode": "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",
  "deployedBytecode": "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",
  "linkReferences": {},
  "deployedLinkReferences": {}
};

export default BrazilCarbonCreditUnified;
